import React from 'react';
import YouTube from 'react-youtube';

const YouTubePlayer = ({ youtubeLink }) => {

// console.log("IDDDDDDD", youtubeLink);

    // Extract the video ID from the YouTube link
    const videoId = youtubeLink.split('/').pop();

    const opts = {
        height: '315',
        width: '100%',
        playerVars: {
            autoplay: 1,
            controls: 1,
            showinfo: 0,
            rel: 0,
        },
    };

    return (
        <div className='row'>
            <div className='col-md-12'>
                <YouTube videoId={videoId} opts={opts} style={{ marginTop: '10px' }} />
            </div>
        </div>
    )
};

export default YouTubePlayer;
